<div class="wrap">
    <app-header></app-header>
    <div class="main-holder">
        <app-nav></app-nav>
        <div class="main">
            <div class="main-content">
                <div class="bread">
                    <ol *ngIf="!showDetails">
                        <li><a [routerLink]="['/']"><img src="../../../../assets/okito/images/icons/home.svg"></a></li>
                        <img src="../../../../assets/okito/images/icons/chevron-right.svg">
                        <li><span>TNVS Fare Configuration</span></li>
                    </ol>
                    <ol *ngIf="showDetails">
                        <li><a [routerLink]="['/']"><img src="../../../../assets/okito/images/icons/home.svg"></a></li>
                        <img src="../../../../assets/okito/images/icons/chevron-right.svg">
                        <li><a (click)="returnToList()" style="cursor: pointer;">TNVS Fare Configuration</a></li>
                        <img src="../../../../assets/okito/images/icons/chevron-right.svg">
                        <li><span>{{ detailViewed!.title }}</span></li>
                    </ol>
                </div>
                <div class="content-title">
                    <h2>TNVS Fare Configuration</h2>
                </div>
                <hr>

                <!-- LIST -->
                <div class="list-holder" *ngIf="!showDetails">
                    <div class="tools">
                        <div class="search mg-right-auto">
                            <span class="fare-hint">
                                One row per bookable vehicle. The consumer app renders whatever is here, so rows can be
                                edited and deactivated, not added or removed.
                            </span>
                        </div>
                    </div>
                    <div class="list">
                        <table>
                            <thead>
                                <tr>
                                    <th>Service</th>
                                    <th>Vehicle</th>
                                    <th>Seats</th>
                                    <th>Base Fare</th>
                                    <th>Per Minute</th>
                                    <th>Per Kilometre</th>
                                    <th>Status</th>
                                    <th>Last Updated</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngIf="configs.length !== 0; else noRecords">
                                    <tr *ngFor="let config of configs">
                                        <td>{{ serviceLabel(config.rideType) }}</td>
                                        <td>{{ config.title }}</td>
                                        <td>{{ config.seatCount }}</td>
                                        <td>&#8369;{{ config.tnvsBasePrice | number:'1.2-2' }}</td>
                                        <td>&#8369;{{ config.tnvsPricePerMin | number:'1.2-2' }}</td>
                                        <td>&#8369;{{ config.tnvsPriceKm | number:'1.2-2' }}</td>
                                        <td>{{ config.status ? 'Active' : 'Inactive' }}</td>
                                        <td>{{ config.dateUpdated | date:'MM-dd-yyyy h:mm a' }}</td>
                                        <td><a (click)="viewDetails(config)" style="cursor: pointer;">View</a></td>
                                    </tr>
                                </ng-container>
                                <ng-template #noRecords>
                                    <tr>
                                        <td colspan="9" class="no-records-msg">
                                            <h6 class="ponds-contents-med-bold" *ngIf="isLoading">Loading…</h6>
                                            <h6 class="ponds-contents-med-bold" *ngIf="!isLoading && loadError === 'unsupported'">
                                                Not available on this environment yet.
                                            </h6>
                                            <h6 class="ponds-contents-med-bold" *ngIf="!isLoading && loadError === 'failed'">
                                                Connection not available. Please try again.
                                            </h6>
                                            <h6 class="ponds-contents-med-bold" *ngIf="!isLoading && loadError === 'none'">
                                                No records found
                                            </h6>
                                        </td>
                                    </tr>
                                </ng-template>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- DETAIL / EDIT -->
                <div class="list-holder" *ngIf="showDetails && detailViewed">
                    <div class="tools">
                        <div class="search mg-right-auto"></div>
                        <div class="profile-actions">
                            <button class="btn btn-sm btn-default" style="min-width: 100px;"
                                (click)="enableEditForm()" *ngIf="!enableEdit && canManage">Edit Details</button>
                            <button class="btn btn-sm btn-default" style="min-width: 100px;"
                                [disabled]="isSaving"
                                (click)="confirmUpdate(confirmUpdateModal)" *ngIf="enableEdit">Save</button>
                            <button class="btn btn-sm btn-outline" style="min-width: 100px;"
                                [disabled]="isSaving"
                                (click)="disableEditForm()" *ngIf="enableEdit">Cancel</button>
                            <button class="btn btn-sm btn-outline" style="min-width: 100px;"
                                (click)="returnToList()" *ngIf="!enableEdit">Back to List</button>
                        </div>
                    </div>

                    <div class="panel">
                        <div class="panel-info">
                            <div class="form-item">
                                <label class="form-label">Service</label>
                                <!-- Never editable: this is what the consumer app filters vehicles on. -->
                                <input type="text" class="form-control"
                                    [value]="serviceLabel(detailViewed.rideType)" disabled="true">
                                <small class="fare-hint">
                                    Fixed. Moving a vehicle to another service would change what every app already
                                    installed shows.
                                </small>
                            </div>

                            <div class="form-item">
                                <label class="form-label">Vehicle Name</label>
                                <input type="text" class="form-control" maxlength="60"
                                    placeholder="e.g. Ok! Ride Car"
                                    [(ngModel)]="form.title" [disabled]="!enableEdit">
                            </div>

                            <div class="form-item">
                                <label class="form-label">Seats</label>
                                <input type="number" class="form-control" min="1" step="1"
                                    [(ngModel)]="form.seatCount" [disabled]="!enableEdit">
                            </div>

                            <div class="form-item">
                                <label class="form-label">Description</label>
                                <input type="text" class="form-control" maxlength="200"
                                    placeholder="Shown under the vehicle name in the app"
                                    [(ngModel)]="form.description" [disabled]="!enableEdit">
                            </div>

                            <div class="form-item">
                                <label class="form-label">Icon</label>
                                <input type="text" class="form-control"
                                    placeholder="Icon URL shown in the app's vehicle picker"
                                    [(ngModel)]="form.icon" [disabled]="!enableEdit">
                                <div class="fare-icon-preview" *ngIf="form.icon">
                                    <img [src]="form.icon" alt="" onerror="this.style.display='none'">
                                </div>
                            </div>

                            <div class="form-item">
                                <label class="form-label">Base Fare (&#8369;)</label>
                                <input type="number" class="form-control" min="0" step="0.01"
                                    [(ngModel)]="form.tnvsBasePrice" [disabled]="!enableEdit">
                                <small class="fare-hint">Charged on every booking before distance and time.</small>
                            </div>

                            <div class="form-item">
                                <label class="form-label">Price per Minute (&#8369;)</label>
                                <input type="number" class="form-control" min="0" step="0.01"
                                    [(ngModel)]="form.tnvsPricePerMin" [disabled]="!enableEdit">
                                <small class="fare-hint">
                                    Applied to OK! Ride and OK! Taxi only; MotoTaxi is priced on distance alone.
                                </small>
                            </div>

                            <div class="form-item">
                                <label class="form-label">Price per Kilometre (&#8369;)</label>
                                <input type="number" class="form-control" min="0" step="0.01"
                                    [(ngModel)]="form.tnvsPriceKm" [disabled]="!enableEdit">
                            </div>

                            <div class="form-item">
                                <label class="form-label">Status</label>
                                <select class="form-select" [disabled]="!enableEdit" [(ngModel)]="form.status">
                                    <option [ngValue]="true">Active</option>
                                    <option [ngValue]="false">Inactive</option>
                                </select>
                                <small class="fare-hint">
                                    Inactive vehicles disappear from the app's picker but stay listed here.
                                </small>
                            </div>

                            <div class="form-item">
                                <label class="form-label">Last Updated</label>
                                <input type="text" class="form-control"
                                    [value]="(detailViewed.dateUpdated | date:'MM-dd-yyyy h:mm a') || ''"
                                    disabled="true">
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<ng-template #confirmUpdateModal let-modal class="modal">
    <div class="modal-header">
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <p>
            Are you sure you want to update the fare for
            <strong>{{ detailViewed!.title }}</strong> ({{ serviceLabel(detailViewed!.rideType) }})?
            This applies to every new fare estimate on that vehicle.
        </p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline" (click)="modal.dismiss('Cross click')">No, Cancel it</button>
        <button type="button" class="btn btn-default" [disabled]="isSaving"
            (click)="updateConfig(successUpdateModal)">Yes, Update</button>
    </div>
</ng-template>

<ng-template #successUpdateModal let-modal class="modal">
    <div class="modal-header">
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body success-body">
        <img src="../../../../assets/okito/images/modal-success.svg">
        <p>Fare configuration successfully updated</p>
        <button class="btn btn-default" (click)="closeAllModals()">Close</button>
    </div>
</ng-template>
